export const messageTypes = {
    HIGH: 'high',
    REGULAR: 'regular',
    LOW: 'low'
};
